import {
  Modal,
  message,
  Row,
  Col,
  Button,
  Table,
  Input,
  FloatButton,
  Spin,
  notification,
  Form,
  Space,
} from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_UPDATE_PARCEL,
} from "../../../API/apiUrls";
import { FileExcelOutlined, SaveOutlined } from "@ant-design/icons";
import { findParcelDuplicates } from "../../../../hook/CheckDuplicateParcel";
import { excelForPostOffice } from "../export/ExportPostOffice";

const AddBarcode = ({ open, close, data, typePay, typeContract }) => {
  const { Search } = Input;
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState(data);
  const [arrData, setArrData] = useState(data);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [form] = Form.useForm();
  const mailRefs = useRef({}); // ช่อง ems จดหมายของแต่ละแถว
  const responseRefs = useRef({}); // ช่อง ems ใบตอบกลับของแต่ละแถว
  const scrollRef = useRef(null); // กล่องที่ให้เลื่อนภายใน

  // เติมค่าเริ่มต้นเข้า Form ทุกครั้งที่ arrayTable เปลี่ยน
  useEffect(() => {
    const rowsObj = arrayTable.reduce((acc, r) => {
      acc[r.key] = {
        parcelNo: r.parcelNo ?? "",
        parcelNoResponse: r.parcelNoResponse ?? "",
      };
      return acc;
    }, {});
    form.setFieldsValue({ rows: rowsObj });
  }, [arrayTable, form]);

  // เขียน helper ให้ mirror ค่าลง state ของตาราง (เพื่อให้ render ทันที)
  const writeThrough = (rowKey, field, val) => {
    setArrayTable((prev) =>
      prev.map((r) => (r.key === rowKey ? { ...r, [field]: val } : r))
    );
    setArrData((prev) =>
      prev.map((r) => (r.key === rowKey ? { ...r, [field]: val } : r))
    );
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    onSearch(event.target.value);
  };

  const onSearch = (value) => {
    console.log("value", value);
    console.log("arrData", arrData);

    let result = arrData?.filter(
      (item) =>
        item.contractNo.includes(value.trim()) ||
        item.customerFullname.includes(value.trim()) ||
        item?.parcelNo === value.trim() ||
        item?.parcelNoResponse === value.trim()
    );
    console.log("sadasdadasd", result);
    if (value) {
      console.log(arrayTable);
      setArrayTable(result);
    } else {
      console.log(arrData);
      setArrayTable(arrData);
    }
  };

  const putDataParcel = async (dataParcel) => {
    setLoading(true);
    if (!dataParcel || dataParcel.length === 0) {
      message.error("ไม่มีข้อมูล !!");
      setLoading(false);
      return;
    }
    console.log("dataParcel", dataParcel);

    try {
      const res = await axios.post(
        `${BASE_URL_BEN}${POST_UPDATE_PARCEL}`,
        dataParcel,
        { headers: HEADERS_EXPORT_BEN }
      );
      const { status, data } = res;

      if (status === 200) {
        message.success("สร้างข้อมูลใหม่สำเร็จ");
      } else if (status === 201) {
        message.warning(String(data?.OK));
      } else {
        message.success(`สำเร็จ (รหัส ${status})`);
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 500) {
        message.error(`ข้อมูลเลขไปรษณีย์ซ้ำ !!`);
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const confirmInsert = () => {
    setLoading(true);
    const { sameField, crossField } = findParcelDuplicates(arrayTable);

    if (sameField.length || crossField.length) {
      notification.error({
        message: "ไม่สามารถบันทึกได้ !",
        description: (
          <div>
            <div>เนื่องจากมีข้อมูลซ้ำกันกรุณาตรวจสอบข้อมูล !</div>

            {sameField.length > 0 && (
              <div style={{ marginTop: 8, color: "red" }}>
                ซ้ำกันในแถว:
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {[...new Set(sameField.map((d) => d.value))].map(
                    (value, index) => (
                      <li key={index}>{value} </li>
                    )
                  )}
                </ul>
              </div>
            )}

            {crossField.length > 0 && (
              <div style={{ marginTop: 8, color: "orange" }}>
                ซ้ำข้ามคอลัมน์:
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {[...new Set(crossField.map((d) => d.value))].map(
                    (value, index) => (
                      <li key={index}>{value}</li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>
        ),
        duration: 10,
      });

      setLoading(false);
      return;
    }

    const use = arrayTable.filter((r) => r.parcelNo && r.parcelNoResponse);
    console.log(use);

    putDataParcel(use);
  };

  const handleExportExcel = async () => {
    setLoading(true);

    console.log(selectedRows);

    let useData;
    if (selectedRows.length > 0) {
      useData = selectedRows;
    } else {
      useData = arrayTable;
    }

    try {
      await excelForPostOffice(useData, 1, typePay, typeContract);
      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const renderParcelNo = (_, record, index) => (
    <Form.Item
      name={["rows", record.key, "parcelNo"]}
      style={{ margin: 0 }}
      rules={[
        {
          required: true,
          message: "กรุณากรอกเลข ems จดหมาย",
        },
        {
          len: 13,
          message: "ต้อง 13 หลัก",
        },
      ]}
      getValueFromEvent={(e) => e.target.value}
    >
      <Input
        placeholder="กรอกเลข ems จดหมาย"
        maxLength={13}
        minLength={13}
        ref={(el) => (mailRefs.current[index] = el)}
        onChange={(e) => {
          const v = e.target.value.trim();
          writeThrough(record.key, "parcelNo", v);
          if (v.length === 13) responseRefs.current[index]?.focus();
        }}
        onPressEnter={() => responseRefs.current[index]?.focus()}
      />
    </Form.Item>
  );

  const renderParcelNoResponse = (_, record, index) => (
    <Form.Item
      name={["rows", record.key, "parcelNoResponse"]}
      style={{ margin: 0 }}
      rules={[
        {
          required: true,
          message: "กรุณากรอกเลข ems จดหมาย",
        },
        {
          len: 13,
          message: "ต้อง 13 หลัก",
        },
      ]}
      getValueFromEvent={(e) => e.target.value}
    >
      <Input
        placeholder="กรอกเลข ems ใบตอบกลับ"
        maxLength={13}
        minLength={13}
        ref={(el) => (responseRefs.current[index] = el)}
        onChange={(e) => {
          const v = e.target.value.trim();
          writeThrough(record.key, "parcelNoResponse", v);
          if (v.length === 13) mailRefs.current[index + 1]?.focus();
        }}
        onPressEnter={() => mailRefs.current[index + 1]?.focus()}
      />
    </Form.Item>
  );

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",

      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "contractNo",
      key: "contractNo",
      align: "center",

      render: (_, r) => r.contractNo || r.CONTNO || "-",
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "customerFullname",
      key: "customerFullname",
      align: "center",

      render: (_, r) => r.customerFullname || r.NAME || "-",
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",

      render: (_, r) =>
        r.customerTypeID === 0 ? "ผู้เช่าซื้อ" : `คนค้ำ ${r.customerTypeID}`,
    },
    {
      title: "ที่อยู่",
      align: "left",
      render: (_, r) => r.ADDR || "-",
    },
    {
      title: "ems จดหมาย",
      dataIndex: "parcelNo",
      key: "parcelNo",
      align: "center",
      width: 220,
      render: renderParcelNo,
    },
    {
      title: "ems ใบตอบกลับ",
      dataIndex: "parcelNoResponse",
      key: "parcelNoResponse",
      align: "center",
      width: 220,
      render: renderParcelNoResponse,
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const btnSubmit = () => {
    form.submit(); // ส่งฟอร์มเมื่อกด "ยืนยัน"
  };

  const TableData = () => {
    return (
      <div
        ref={scrollRef}
        style={{
          maxHeight: 800, // กำหนดความสูงให้เกิดสกอร์ล
          overflow: "auto",
          position: "relative", // ให้ float วางอิงกล่องนี้ได้
        }}
      >
        <Row gutter={[16, 16]} align="middle" wrap>
          <Col xs={24} md={12} style={{ textAlign: "start" }}>
            <Search
              enterButton="ค้นหา"
              placeholder="ค้นหาสัญญา"
              onChange={search}
              size="large" // small = 24px, middle = 32px, large = 40px
              style={{ width: "60%", maxWidth: 320, padding: 10 }} // พอดีสายตา, ไม่ยืดเกินไป
            />
          </Col>
          <Col xs={24} md={12} style={{ textAlign: "end" }}>
            <Space size={8} wrap>
              <Button
                type="primary"
                ghost
                icon={<SaveOutlined />}
                loading={loading}
                size="middle"
                style={{ borderRadius: 8, fontWeight: 600 }}
                onClick={() => btnSubmit()}
              >
                บันทึก
              </Button>

              <Button
                icon={<FileExcelOutlined />}
                size="middle"
                loading={loading}
                style={{
                  borderRadius: 8,
                  fontWeight: 600,
                  color: "#16a34a",
                  borderColor: "#16a34a",
                }}
                onClick={handleExportExcel}
              >
                ออก Excel
              </Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form
              form={form}
              onFinish={(values) => {
                const payload = arrayTable.map((r) => ({
                  ...r,
                  ...(values.rows?.[r.key] || {}),
                }));
                console.log("submit payload", payload);
                confirmInsert();
              }}
              onFinishFailed={(errorInfo) => {
                const fieldLabels = {
                  parcelNo: "ems จดหมาย",
                  parcelNoResponse: "ems ใบตอบกลับ",
                };

                // แปลง key → เลขแถว (index + 1)
                const keyToRowNo = (rowKey) => {
                  const i = arrayTable.findIndex(
                    (r) => String(r.key) === String(rowKey)
                  );
                  return i >= 0 ? i + 1 : rowKey;
                };
                notification.error({
                  message: "ไม่สามารถบันทึกได้ !",
                  description: (
                    <div>
                      <div
                        style={{
                          marginTop: 8,
                          color: "red",
                        }}
                      >
                        ข้อมูลไม่ครบในคอลัมน์และแถว
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                          {[
                            ...new Set(
                              errorInfo.errorFields.map((d) => {
                                const [, rowKey, field] = d.name || [];
                                const label = fieldLabels[field] || field;
                                return `คอลัมน์ ${label} ที่แถว ${keyToRowNo(
                                  rowKey
                                )}`;
                              })
                            ),
                          ].map((value, index) => (
                            <li key={index}>{value}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ),
                  duration: 6,
                });
                console.log("errorInfo", errorInfo);
              }}
            >
              <Table
                size="large"
                rowKey={(r) => r.key}
                columns={columns}
                dataSource={arrayTable}
                pagination={false}
                bordered
                style={{ marginTop: 16 }}
                footer={() => (
                  <div
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    จำนวนทั้งหมด {arrayTable.length}
                  </div>
                )}
                rowSelection={rowSelection}
              />
            </Form>
            <FloatButton.BackTop />
          </Col>
        </Row>
        <FloatButton.BackTop
          target={() => scrollRef.current} // ฟังสกอร์ลจากกล่องนี้
          visibilityHeight={80} // โผล่เมื่อเลื่อนเกิน 80px
          style={{ right: 16, bottom: 16 }}
        />
      </div>
    );
  };

  return (
    <Spin spinning={loading} size="large" tip=" Loading... ">
      <Modal
        title={
          <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
            รายการออกบอกเลิก
          </span>
        }
        open={open}
        onCancel={handleCancel}
        width={data.length > 0 ? "auto" : 850}
        footer={null}
        keyboard={true}
        maskClosable={false}
        centered
        styles={{
          body: { padding: "24px 32px" }, // ใช้แทน styles.body
        }}
      >
        {TableData()}
      </Modal>
    </Spin>
  );
};
export default AddBarcode;
